module.exports = __webpack_public_path__ + "static/media/amy_english_british.416bee02.mp3";